import { actions } from './laboratory_conclusions/actions'
import { getters } from './laboratory_conclusions/getters'
import { state } from './laboratory_conclusions/state'
import { mutations } from './laboratory_conclusions/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
